import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class CardInView {
	constructor(elm) {
        this.elm = elm;

        this.trigger = ScrollTrigger.create({
            trigger:  this.elm,
            start: "top 90%",
            onEnter: () => {
                this.elm.classList.add('is-inview');
            }
        });

    }

    destroy() {
       this.trigger.kill();
    }
}